export default class Pair<A, B> {
  constructor(
    public readonly first: A,
    public readonly second: B
  ) {}

  static of<A, B>(first: A, second: B): Pair<A, B> {
    return new Pair(first, second)
  }

  toString() {
    return `(${this.first}, ${this.second})`
  }
}